module.exports = __webpack_public_path__ + "static/got-9b36c9002aaccb2433aca71ee377495e.jpg";